import { render, staticRenderFns } from "./ObserveModule.vue?vue&type=template&id=2ac3743a"
import script from "./ObserveModule.vue?vue&type=script&lang=js"
export * from "./ObserveModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports